module.exports = __webpack_public_path__ + "static/media/team_5.3288f558.jpg";